import React, { Component } from "react";

import "./HairPopupModal.css";

class HairPopupModal extends Component {
  render() {
    return (
      <div className="hair-popup-modal__body">
        <img
          className="hair-popup-modal__icon"
          src={`/images/hair/profile/${
            !localStorage.getItem("user_id")
              ? "no-skin-profile.png"
              : !localStorage.getItem("user_has_hair_profile")
              ? "no-hair-profile.svg"
              : "no-skin-profile.png"
          }`}
        />
        <h3 className="hair-popup-modal__header">
          You don't have a {this.props.showHair ? "hair" : "skin"} profile set
          up.
        </h3>
        <a href={this.props.showHair ? "/hair/onboarding" : "/onboarding"}>
          <button className="hair-popup-modal__button">
            Start {this.props.showHair ? "Hair" : "Skin"} Quiz
          </button>
        </a>
      </div>
    );
  }
}
export default HairPopupModal;



// WEBPACK FOOTER //
// ./src/components/hair/popup/HairPopupModal.js